/* Heart-save on product cards. Saved handles live in localStorage so
   hearts survive reloads; no account or app required. */
(function () {
  var KEY = 'sugar-wishlist';

  function read() {
    try {
      return JSON.parse(localStorage.getItem(KEY)) || [];
    } catch (e) {
      return [];
    }
  }

  function write(list) {
    try {
      localStorage.setItem(KEY, JSON.stringify(list));
    } catch (e) {
      /* private mode: hearts still toggle, just don't persist */
    }
  }

  function sync(root) {
    var saved = read();
    (root || document).querySelectorAll('[data-sugar-wishlist]').forEach(function (btn) {
      var on = saved.indexOf(btn.dataset.productHandle) !== -1;
      btn.classList.toggle('on', on);
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
  }

  document.addEventListener('click', function (event) {
    var btn = event.target.closest('[data-sugar-wishlist]');
    if (!btn) return;
    event.preventDefault();
    event.stopPropagation();
    var handle = btn.dataset.productHandle;
    var saved = read();
    var i = saved.indexOf(handle);
    if (i === -1) saved.push(handle);
    else saved.splice(i, 1);
    write(saved);
    document.querySelectorAll('[data-sugar-wishlist][data-product-handle="' + handle + '"]').forEach(function (b) {
      b.classList.toggle('on', i === -1);
      b.setAttribute('aria-pressed', i === -1 ? 'true' : 'false');
    });
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      sync();
    });
  } else {
    sync();
  }

  /* re-sync hearts inside sections the theme editor re-renders */
  document.addEventListener('shopify:section:load', function (event) {
    sync(event.target);
  });
})();
